<template>
    <option disabled value="0">--Sila Pilih--</option>
</template>
<script>
export default {
  name: "DefaultOption",
}
</script>
